import Vue from 'vue'
import { API } from '../../services'
import { vuexMapDefaultsGetters, vuexMapDefaultsMutations } from '../../utils'
import { multiSelect } from 'src/common/selectors'

const defaultState = () => {
  return {
    ...multiSelect.mapStates(['companies', 'employees']),
    loading: false,
    currentReqId: null,
    list: []
  }
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState())
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  ...multiSelect.mapMutations(['companies', 'employees']),
  list: (state, payload) => {
    Vue.set(state, 'list', payload)
  },
  resetList: (state) => {
    Vue.set(state, 'list', [])
  },
  changeApproval: (state, {id, approved}) => {
    Vue.set(state, 'list', state.list.map(employee => {
      return {
        ...employee,
        biometrics: employee.biometrics.map(bio => {
          if (bio.id === id) {
            return {...bio, approved: approved}
          }
          return {...bio}
        })
      }
    }))
  },
  setImageInBiometric: (state, {employeeId, biometricId, image}) => {
    const biometricInfo = state.list.find(info => info.employee.id === employeeId)
    const biometric = biometricInfo.biometrics.find(biometric => biometric.id === biometricId)
    Vue.set(biometric, 'imageUrl', image)
  }
}

const actions = {
  loadBiometrics: async ({state, commit}, {reqId, params}) => {
    commit('currentReqId', reqId)
    commit('loading', true)
    try {
      console.log(params)
      const result = await API.biometric.save({
        ...params
      })
      console.log(result)
      return result
    } catch (e) {
      console.log(e)
      return e
    } finally {
      commit('loading', false)
    }
  },
  async loadImagesFromBiometric ({state, commit}, {employeeId}) {
    const employeeBiometricInfo = state.list.find(info => info.employee.id === employeeId)

    const fetchImagesPromises = employeeBiometricInfo.biometrics.map(biometric => {
      return API.safeGetImages.get({
        model: 'biometrics',
        id: biometric.id
      }).then(result => {
        if (result.status === 200) {
          commit('setImageInBiometric', {
            employeeId,
            biometricId: biometric.id,
            image: result.body.success['img_b64']
          })
        }
      })
    })

    await Promise.all(fetchImagesPromises)
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
